import React from "react";
import { Spin, Progress, message, Icon, Button } from "antd";
import queryString from "query-string";

import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import CloudFlyerAPI from "../../../api/CloudFlyerAPI";
import { resendVerificationEmail } from "../../../actions/auth";

import accountVerifiedImage from "../../../assets/img/account_verified.png";
import "./index.scss";

import warningIcon from '../../../assets/img/warning.png';
import tickIcon from '../../../assets/img/Transfer_Start.png';
import ModalB from '../../../components/UI/Modal/ModalB';
import BackDrop from '../../../components/UI/Backdrop/Backdrop';

class VerifyUser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      verifying: false,
      verified: false,
      
      // POP UP
      popUp:false,
      popUpMessage:{},
    };
  }

  componentDidMount() {
    this.setState({ verifying: true });
    try {
      let $this = this;
      let token = queryString.parse(this.props.location.search).token;

      CloudFlyerAPI.user_account
        .verifyUserAccount(token)
        .then(() => {
          $this.setState({ verified: true, verifying: false });
        })
        .catch(() => {
          $this.setState({ 
            verified: false, 
            verifying: false,
            popUp:true,
            popUpMessage:{
              icon:warningIcon,
              header:"Verification Error",
              text:{
                  1:"Your email has not yet been verified.",
                  2:"Please go to your email and finish",
                  3:"the verification process in order to login."
              },
              button:"OK"
            }
          });

          message.error("Email verification failed");
        });
    } catch (e) {
      console.error(e);
    }

    this.onTimeout = this.onTimeout.bind(this);
  }

  componentDidCatch(err, details) {
    console.error(err, details);
  }

  onTimeout() {
    setTimeout(() => {
      this.on_login();
    }, 5000);
  }
  on_login = () => {
    const { history } = this.props;
    history.push("/login");
  };

  //  to close the popUp using the backdrop
  closePopUpHandler = () =>{
    this.setState({ popUp: false })
  }
  
  render() {

    // POP UPS
    const popUpComponent = this.state.popUp ? 
    <div>
        <BackDrop show={this.state.popUp} close={this.closePopUpHandler}/>
        <ModalB 
            show={this.state.popUp}
            icon={this.state.popUpMessage.icon}
            header={this.state.popUpMessage.header}
            text={this.state.popUpMessage.text}
            button={this.state.popUpMessage.button}
            close={this.closePopUpHandler}
        /> 
    </div>:null;

    let { verifying, verified } = this.state;

    let msgComponent;

    if (verifying) {
      msgComponent = <Verifying />;
    } else if (verified) {
      msgComponent = <AccountVerified />;
      this.onTimeout();
    } else {
      // msgComponent = <AccountNotVerified />;
      msgComponent = popUpComponent;
    }

    return (
      <div className="verify-user">
        <div className="confirmation">
          <div className="cs-header">
            <h2 className="logo">
              <span>logo</span>
            </h2>
          </div>
          <div className="cs-body">{msgComponent}</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return auth;
}

function mapDispatchToProps(dispatch) {
  return {
    resendVerificationEmail: bindActionCreators(
      resendVerificationEmail,
      dispatch
    )
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(VerifyUser)
);

const Verifying = props => {
  return (
    <div className="verifying">
      <Icon type="loading" className="loading" />
      <h1 className="verifying-header">Verifying ...</h1>
      <p>Please wait a moment</p>
    </div>
  );
};

const AccountNotVerified = props => {
  return (
    <div className="account-not-verified">
      <h1 className="fail-header">Verification Failed</h1>
      <Icon type="warning" className="warning" />
      <p>Could Not Verify Account</p>
    </div>
  );
};

class AccountVerified extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="account-verified">
        <header>Your account is verified!</header>
        <p>
          Give us few seconds to provision <br />
          and get you to the login page.
        </p>
        <div className="img-container">
          <img alt="" src={accountVerifiedImage} />
        </div>
        <footer>
          If you're not directed to the login page within 15 seconds, click
          &nbsp;
          <a href="#">here</a>.
        </footer>
      </div>
    );
  }
}
